<script>
import { Bar, Charts } from "vue-chartjs";
/* let colors = ["#163F5E", "#20639B", "#3CAEA3", "#F7D45C", "#EE563B"]; */
let colors = ["#006E90", "#FFBC42", "#FF5E5B", "#00CECB", "#B9E6FF"];
export default {
  extends: Bar,

  data() {
    return {
      //
      chart_options: {
        legend: {
          position: "bottom",
        },
        title: {
          display: true,
          text: this.title_text,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                stepSize: parseFloat(this.step_size),
                max: parseInt(this.range.max),
                min: 0,
              },
            },
          ],
          xAxes: [],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datas: this.datas_bar,
    };
  },
  mounted() {
    console.log(this.print);
    if (this.static_chart_data.labels.length > 0) {
      this.drawBarsGraph(this.static_chart_data);
    }
    if (this.fixedLabelXAxis) {
      this.chart_options.scales.xAxes.push({
        ticks: {
          callback: function (value) {
            if (value.length > 40) {
              return value.substr(0, 40) + " ...";
            } else {
              return value;
            }
          },
        },
      });
    }
    if (this.print) {
      this.chart_options.scales.xAxes.push({
        ticks: {
          fontSize: 9,
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
          callback: function (value) {
            if (value.length > 20) {
              return value.substr(0, 20) + " ...";
            } else {
              return value;
            }
          },
        },
      });
    }
  },
  methods: {
    drawBarsGraph(datas_bar) {
      let componentGraph = this;
      let labels = datas_bar.labels;
      datas_bar.datasets.forEach((el, i) => {
        el.backgroundColor = colors[i];
        el.borderColor = colors[i];
      });
      let final = { labels, datasets: datas_bar.datasets };
      setTimeout(function () {
        componentGraph.renderChart(final, componentGraph.chart_options);
      }, 1000);
    },
  },
  props: {
    fixedLabelXAxis: {
      type: Boolean,
      required: false,
      default: false,
    },
    print: {
      type: Boolean,
      required: false,
      default: false,
    },
    static_chart_data: {
      type: Object,
      required: false,
      default() {
        return {
          labels: [],
          datasets: [],
        };
      },
    },
    range: {
      type: Object,
      required: true,
    },
    step_size: {
      type: Number,
      required: false,
      default: 0.5,
    },
    title_text: {
      type: String,
      required: false,
      default: "Prestazioni erogate",
    },
  },
};
</script>
